import React, { useContext, useState } from "react";

export const CampaignContext = React.createContext({
  selectedCampaign: "",
  campaignList: [],
  isAiCoachingEnabled: false,
});

export function CampaignProvider({ children }) {
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [campaignList, setCampaignList] = useState([]);
  // AI Coaching pilot region gate: coaches only ever work campaigns in their
  // own home region, so this is a single flag for the logged-in coach (from
  // /api/getUserCampaignList's ai_coaching_enabled field), not derived per
  // selected campaign. See alt-ai-coaching-pilot.md.
  const [isAiCoachingEnabled, setIsAiCoachingEnabled] = useState(false);

  const contextValue = {
    selectedCampaign,
    campaignList,
    isAiCoachingEnabled,
    setSelectedCampaign,
    setCampaignList,
    setIsAiCoachingEnabled,
  };

  return (
    <CampaignContext.Provider value={contextValue}>
      {children}
    </CampaignContext.Provider>
  );
}

export function useCampaign() {
  const {
    selectedCampaign,
    setSelectedCampaign,
    campaignList,
    setCampaignList,
    isAiCoachingEnabled,
    setIsAiCoachingEnabled,
  } = useContext(CampaignContext);
  return {
    selectedCampaign,
    setSelectedCampaign,
    campaignList,
    setCampaignList,
    isAiCoachingEnabled,
    setIsAiCoachingEnabled,
  };
}
